const from =
  'àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ'
const to =
  'aaaaaaaaaaaaaaaaaeeeeeeeeeeeduuuuuuuuuuuoooooooooooooooooiiiiiaeiiouuncyyyyy'

const map: {
  [key: string]: string
} = {}
for (let i = 0; i < from.length; i++) {
  map[from[i]] = to[i]
}
export function trimVietnameseAccent(str = '') {
  str = str
    .replace(/./g, (c) => map[c] || c)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\-]/g, ' ')
    .replace(/-+/g, '-')

  return str
}
